<template>
  <div>
    <h1>LINE接続作業ウィザード</h1>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <div class="form-check">
          <input id="operation-type-call" type="radio" value="PLC" name="operation-type" class="form-check-input" v-model="operationType" disabled>
          <label for="operation-type-call" class="form-check-label">Call LINEオプション</label>
        </div>
        <div class="form-check">
          <input id="operation-type-cx" type="radio" value="PLCX" name="operation-type" class="form-check-input" v-model="operationType">
          <label for="operation-type-cx" class="form-check-label">CX</label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="商談ID" v-model="sfOpportunityId" />
        <button class="btn btn-other-action" @click="loadSfOpportunity" :disabled="operationType === ''">SFから読み込み</button>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="ショップID" v-model="shopId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="医院名" v-model="name" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="フォロー担当者" v-model="follow" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="開始希望日yyyy-mm-dd" v-model="startHopeDate" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="有償開始日yyyy-mm-dd" v-model="startPaymentDate" />
        <input type="button" value="開始希望日から算出" class="btn btn-other-action" @click="calcStartPaymentDate" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <select id="plan" class="form-control" v-model="selectedPlan">
          <option disabled value="">プランを選択</option>
          <option v-for="plan in plans" :key="plan.title" :value="plan.title">
            {{ plan.title }}
          </option>
        </select>
      </div>
    </div>

    <div v-if="currentStep === 0">
      <h2>1. LINE OAM権限の取得</h2>
      <ol>
        <li>
          営業担当より、LINE OAM権限を取得するためのURLの提供を受ける<br>
          ※1人にしか紐づけられないURLなので、SCOグループ堂谷のアカウントでアクセスする
        </li>
        <li>
          LINEアカウントでログイン＞SCOグループ 堂谷＞アカウントリストに追加される<br>
          このとき、権限が「管理者」であることを確認し、運用担当者等の管理者以外の場合は営業担当に連絡する（差し戻し）
        </li>
      </ol>
      <textarea readonly :value="oamRetryTxt" class="form-control" rows="5"></textarea>
      <input type="button" value="コピー" class="btn btn-other-action" @click="copy(oamRetryTxt)" />
    </div>

    <div v-if="currentStep === 1">
      <h2>2. 事前確認</h2>
      <ol>
        <li><a :href="callListUrl" target="_blank">Callの契約</a>確認（CXと期間の重複したLINE,SMSオプションはNG）</li>
        <li><a :href="insightListUrl" target="_blank">CXの契約</a>確認（CXと期間の重複したLINE,SMSオプションはNG）</li>
        <li><a :href="plxContractListUrl" target="_blank">Xの契約</a>確認（契約内容から利用状況、加盟店設定から機能設定を見る）</li>
      </ol>
    </div>

    <div v-if="currentStep === 2">
      <h2>3. プロバイダの作成</h2>
      医院の公式アカウントにログインして作業を行う。
      <label class="control-label">LINE OAMより、登録情報</label>
      <div class="row">
        <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
          <input class="form-control" type="text" placeholder="医院名(FIX)" v-model="fixedName" />
          医院名未登録や、OAMの名前がイマイチな場合は若干の加工を行う
        </div>
        <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
          <input class="form-control" type="text" placeholder="メールアドレス" v-model="mail" />
        </div>
      </div>

      <ol>
        <li>
          右上の「設定」を押下
        </li>
        <li>
          左メニューの設定>Messaging APIより、「MessagingAPIを利用する」を押下<br>
          既にMessagingAPIが利用中の場合は、手に負えないのでNGT堂谷に連絡する
        </li>
        <li>
          プロバイダ名：{{ fixedName }}
          <input type="button" value="コピー" class="btn btn-other-action" @click="copy(fixedName)" />
        </li>
        <li>
          同意すると「プライバシーポリシー＆利用規約」についてポップアップ⇒スルーしてOK
        </li>
        <li>
          ダイアログ「変更・解除できませんのでご注意ください」⇒アカウント名とプロバイダ名が同一であることを確認してOK<br>
          ※名称変更、再作成はできない
        </li>
      </ol>
    </div>
    <label class="control-label" v-if="currentStep > 2">LINE OAMより、登録情報</label>
    <div class="row" v-if="currentStep > 2">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="医院名(FIX)" v-model="fixedName" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="メールアドレス" v-model="mail" />
      </div>
    </div>


    <div v-if="currentStep === 3">
      <h2>4. Messaging APIの登録</h2>
      <ol>
        <li>
          「その他の設定はLINE Developersコンソールから行えます」を押下
        </li>
        <li>
          画面左上コンソールを押下
        </li>
        <li>
          プロバイダの検索ボックスで該当医院を検索・選択＞該当医院のMessaging APIを開く<br>
          <input type="button" value="プロバイダ名（医院名）をコピー" class="btn btn-other-action" @click="copy(fixedName)" />
        </li>
        <li>
          Messaging API>チャネル基本設定>メールアドレス：{{ mail }}
          <input type="button" value="コピー" class="btn btn-other-action" @click="copy(mail)" />
        </li>
      </ol>
    </div>

    <label class="control-label" v-if="currentStep >= 3">Messaging API</label>
    <div class="row" v-if="currentStep >= 3">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="Messaging API設定>ボットのベーシックID" v-model="messagingBasicId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="チャネル基本設定>チャネルID" v-model="messagingChannelId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="チャネル基本設定>チャネルシークレット" v-model="messagingChannelSecret" />
      </div>
    </div>

    <div v-if="currentStep === 4">
      <h2>5. LINEログインの登録</h2>
      <ol>
        <li>
          パンくずより該当医院のページに戻り、新規チャネル作成>LINEログインを押下
        </li>
        <li>
          <table class="table table-striped">
            <tbody>
            <tr>
              <td>所在地</td>
              <td>日本</td>
            </tr>
            <tr>
              <td>チャネル名</td>
              <td>{{ fixedName }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(fixedName)" /></td>
            </tr>
            <tr>
              <td>チャネル説明</td>
              <td>{{ fixedName }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(fixedName)" /></td>
            </tr>
            <tr>
              <td>アプリタイプ</td>
              <td>ウェブアプリ</td>
            </tr>
            <tr>
              <td>メールアドレス</td>
              <td>{{ mail }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(mail)" /></td>
            </tr>
            </tbody>
          </table>
        </li>
        <li>
          同意する<br>作成
        </li>
        <li>
          作成したLINEログインを開き、<strong>開発中●</strong>を<strong>公開する●</strong>に変更する
        </li>
        <li>
          友達追加オプション>リンクされたLINE公式アカウント>{{ fixedName }}のものを選択・更新
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 5">
      <h2>6. LIFFアプリの登録</h2>
      <ol>
        <li>
          LIFFタブ＞追加
          <table class="table table-striped">
            <tbody>
            <tr>
              <td>LIFFアプリ名</td>
              <td>paylight X<input type="button" value="コピー" class="btn btn-other-action" @click="copy('paylight X')" /></td>
              <td>Callのオプションだとしてもこの名前</td>
            </tr>
            <tr>
              <td>サイズ</td>
              <td>Full</td>
              <td></td>
            </tr>
            <tr>
              <td>エンドポイントURL</td>
              <td><input type="button" value="ダミー値をコピー" class="btn btn-other-action" @click="copy(dummyEndPointUrl)" /></td>
              <td></td>
            </tr>
            <tr>
              <td>Scope</td>
              <td>openid, profile, chat_message.write</td>
              <td>すべてチェック<br>chat_message.write選択でダイアログ表示→有効</td>
            </tr>
            <tr>
              <td>友達追加オプション</td>
              <td>On(aggressive)</td>
              <td></td>
            </tr>
            <tr>
              <td>Scan QR</td>
              <td>OFF</td>
              <td></td>
            </tr>
            <tr>
              <td>モジュールモード</td>
              <td>OFF</td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </li>
      </ol>
    </div>

    <label class="control-label" v-if="currentStep >= 5">LINEログイン</label>
    <div class="row" v-if="currentStep >= 5">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="LIFF>LIFF ID" v-model="liffId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="チャネル基本設定>チャネルID" v-model="liffChannelId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="チャネル基本設定>チャネルシークレット" v-model="liffChannelSecret" />
      </div>
    </div>

    <div v-if="currentStep === 6">
      <h2>7. スプレッドシート更新</h2>
      <a href="https://docs.google.com/spreadsheets/d/1GNuceXzjbQfGpNgfR6FXTaSdfn1zJnO-h9zESQ189kA/edit?resourcekey=&gid=2010041961#gid=2010041961&range=A1" target="_blank">PayLightCall連携SSのシステム部連携用_PLCX</a>に以下を記載する<br>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" readonly :value="opsInsightStartTxt" />
        <input type="button" value="コピー" class="btn btn-other-action" @click="copy(opsInsightStartTxt)" />
      </div>
    </div>

    <div v-if="currentStep === 7">
      <h2>8. SF商談更新</h2>
      SF商談を更新する
      <ol>
        <li>
          LINE連携ステータス：システム連携待ち
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 8">
      <h2>9. glenfiddichへのデータ登録</h2>
      <textarea readonly class="form-control" rows="5">@ops No.**のLINE接続作業をお願いします。</textarea>
    </div>

    <div v-if="currentStep === 9">
      <h2>10. 正式版URLの登録</h2>
      <ol>
        <li>
          スプレッドシートからA-P列を以下にコピー
          <div class="row">
            <div class="form-group col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <input class="form-control" type="text" v-model="ssRecord" />
            </div>
          </div>
        </li>
        <li>
          Messaging API>Messaging API設定>Webhook設定>Webhook URL<br>
          {{ webhookUrl }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(webhookUrl)" /><br>
          検証ボタンを押し、「成功」となることを確認する
        </li>
        <li>
          LINEログイン>LIFF>paylight X>エンドポイントURL<br>
          {{ endPointUrl }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(endPointUrl)" />
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 10">
      <h2>11. webhook設定の更新</h2>
      Messaging API>Messaging API設定>Webhook設定<br>
      表示されるダイアログは「理解しました」に☑する
      <table class="table table-striped">
        <tbody>
        <tr>
          <td>webhook利用</td>
          <td>On</td>
        </tr>
        <tr>
          <td>webhook再送</td>
          <td>On</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div v-if="currentStep === 11">
      <h2>12. スタッフ登録</h2>
      <ol>
        <li>
          paylightになりすましログインする<br>
          <a :href="storeListUrl" target="_blank">加盟店一覧>{{ this.shopId }}を検索</a>>詳細・編集>PLスタッフ一覧>オーナー印がついているアカウント
        </li>
        <li>
          paylight>設定>スタッフ管理>スタッフの新規作成
          <table class="table table-striped">
            <tbody>
            <tr>
              <td>氏名（姓）</td>
              <td>paylight<input type="button" value="コピー" class="btn btn-other-action" @click="copy('paylight')" /></td>
            </tr>
            <tr>
              <td>氏名（名）</td>
              <td>X<input type="button" value="コピー" class="btn btn-other-action" @click="copy('X')" /></td>
            </tr>
            <tr>
              <td>メールアドレス</td>
              <td>pay-light-cx@scogr.co.jp<input type="button" value="コピー" class="btn btn-other-action" @click="copy('pay-light-cx@scogr.co.jp')" /></td>
            </tr>
            <tr>
              <td>ユーザータイプ</td>
              <td>事務長（DM）</td>
            </tr>
            <tr>
              <td>ユーザーロール</td>
              <td>管理</td>
            </tr>
            <tr>
              <td>予約対象</td>
              <td><strong>非対象</strong></td>
            </tr>
            </tbody>
          </table>
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 12">
      <h2>13. SF商談更新</h2>
      LINE連携ステータスを「PL登録中」に更新する
    </div>

    <div v-if="currentStep === 13">
      <h2>14. 加盟店設定より、LINE公式の登録</h2>
      <a :href="plxSettingListUrl" target="_blank">加盟店のX設定</a>より、諸々の値の登録を行う。
      <table class="table table-striped">
        <tbody>
        <tr>
          <td>Developerアカウント</td>
          <td>shun.dotani@scogr.co.jp<input type="button" value="コピー" class="btn btn-other-action" @click="copy('shun.dotani@scogr.co.jp')" /></td>
        </tr>
        <tr>
          <td>LINE公式ID</td>
          <td>LINE公式にログイン直後のURLから、@付きのID</td>
        </tr>
        <tr>
          <td>LINE公式アカウント名</td>
          <td>LINE公式にログイン直後の画面に表示されている、医院の名前</td>
        </tr>
        <tr>
          <td>プロバイダID</td>
          <td>LINE Developerで医院のプロバイダに入ったところのURLから取得</td>
        </tr>
        <tr>
          <td>MessagingAPI チャネルID</td>
          <td>{{ messagingChannelId }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(messagingChannelId)" /></td>
        </tr>
        <tr>
          <td>MessagingAPI ボットベーシックID</td>
          <td>{{ messagingBasicId }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(messagingBasicId)" /></td>
        </tr>
        <tr>
          <td>LINEログイン チャネルID</td>
          <td>{{ liffChannelId }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(liffChannelId)" /></td>
        </tr>
        <tr>
          <td>LINEログイン LIFF ID</td>
          <td>{{ liffId }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(liffId)" /></td>
        </tr>
        <tr>
          <td>開始日</td>
          <td>
            基本的には今日。<br>
            未来日にはまだ対応していないので、<br>
            未来日とする場合はその日が来たら手動で契約の同期を実行すること。
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div v-if="currentStep === 14">
      <h2>15. 営業担当者に作業完了を報告</h2>
      <textarea readonly :value="finishReportTxt" class="form-control" rows="5"></textarea>
      <input type="button" value="コピー" class="btn btn-other-action" @click="copy(finishReportTxt)" />
    </div>

    <button class="btn btn-other-action" @click="beforeStep">前工程</button>
    <button class="btn btn-other-action" @click="nextStep">次工程</button>
  </div>
</template>

<style scoped>
</style>

<script>
const plans = [
  { title: 'スタンダード' },
  { title: 'トライアル' },
  { title: 'エンタープライズ' },
]
const tosId = 3 // 利用規約ID
const campaignName = 'Pay Light CX_トライアル'
const insightImportHeaderColumns = "\"" + [
  'ShopID',
  'SF商談ID（Pay Light CX）',
  '加盟店を特定する情報',
  '申し込み日',
  '利用規約ID',
  '代理店',
  'Pay Light CXプラン名',
  '契約開始日',
  'カスタム月額基本料',
  'カスタム無料上限数',
  'カスタム従量課金単価',
  '月額基本料割引',
  '無料上限数追加',
  '従量課金単価割引',
  'Pay Light CXキャンペーン①',
  'Pay Light CXキャンペーン①開始日',
  'Pay Light CXキャンペーン①終了日',
  'Pay Light CXキャンペーン②',
  'Pay Light CXキャンペーン②開始日',
  'Pay Light CXキャンペーン②終了日'
].join('\",\"') + "\""

const insightImportHeader = [
  '', // 大分類
  insightImportHeaderColumns,
  '', // 必須/任意
  '' // フォーマット
].join('\n')

export default {
  data() {
    return {
      currentStep: 0,
      importApi: true,
      enableImportBtn: true,
      operationType: '',
      dummyEndPointUrl: 'https://chat.clinic.pay-light.com?id_alias=',
      ssRecord: '',
      plans,
      campaignEnableCheck: true,
      selectedPlan: '',
      startHopeDate: '',
      startPaymentDate: '',
      name: '',
      sfOpportunityId: '',
      shopId: '',
      fixedName: '',
      mail: '',
      messagingBasicId: '',
      messagingChannelId: '',
      messagingChannelSecret: '',
      liffId: '',
      liffChannelId: '',
      liffChannelSecret: '',
      follow: ''
    }
  },
  computed: {
    validNext() {
      return this.operationType !== '' &&
             this.shopId !== ''
    },
    oamRetryTxt() {
      return [
        `@${this.follow}へのメンション`,
        `${this.name}さまのLINE OAMの権限が「運用担当者」になっていました。`,
        `「管理者」に変えていただきますよう、医院さまにご連絡をお願いいたします。`
      ].join('\n')
    },
    callListUrl() {
      return `/manage/store_ai_call_contracts?include_workflows=true&shop_id=${this.shopId}`
    },
    insightListUrl() {
      return `/manage/store_insight_contracts?include_workflows=true&shop_id=${this.shopId}`
    },
    plxContractListUrl() {
      return `/manage/store_platform_contracts?shop_id=${this.shopId}`
    },
    plxSettingListUrl() {
      return `/manage/store_platform_settings?shop_id=${this.shopId}`
    },
    opsInsightStartTxt() {
      const today = new Date().toISOString().split('T')[0].replace(/-/g, '/')
      const status = 'システム部依頼中'
      return [
        `${this.operationType}`,
        '=ROW()-3',
        `${this.shopId}`,
        `${this.name}`,
        `${this.liffId}`,
        `${this.liffChannelId}`,
        `${this.liffChannelSecret}`,
        `${this.messagingBasicId}`,
        `${this.messagingChannelId}`,
        `${this.messagingChannelSecret}`,
        `${today}`,
        `${status}`
      ].join('\t')
    },
    webhookUrl() {
      const ssArray = this.ssRecord.split('\t')
      return ssArray[15] // P列: Webhook URL
    },
    endPointUrl() {
      const ssArray = this.ssRecord.split('\t')
      return ssArray[14] // O列: エンドポイントURL
    },
    storeListUrl() {
      return `/manage/store_examinations?shop_id=${this.shopId}`
    },
    finishReportTxt() {
      return [
        `@${this.follow}へのメンション`,
        `${this.name}～商談リンクを添えて～さまのLINE接続設定が完了しました。`,
        ``,
        `1)`,
        `paylight X>設定>チャットより、`,
        `「チャットを利用する」をONするとLINEでのやり取りができるようになります。`,
        `動作確認等お願いいたします。`,
        ``,
        `2)`,
        `SMSやLINEで生成したメッセージの送信開始までに @ngt との調整を完了してください。`,
        ``,
        `@吉岡 茉那香/Manaka Yoshioka`,
        `paylight XにSCOアカウントを追加しておりますので、ご確認願います。`,
      ].join('\n')
    }
  },
  methods: {
    beforeStep() {
      if (this.currentStep > 0) {
        this.currentStep--
      }
    },
    nextStep() {
      if (this.currentStep < 14 && this.validNext) {
        this.currentStep++
      }
    },
    loadSfOpportunity() {
      if (!this.sfOpportunityId) {
        alert('商談IDを入力してください。')
        return
      }

      if(this.operationType === 'PLC') {
        this.loadSfCallOpportunity()
      } else {
        this.loadSfInsightOpportunity()
      }
    },
    calcStartPaymentDate() {
      if (!this.startHopeDate) {
        alert('開始希望日を入力してください。')
        return
      }
      // 開始希望日の翌々月の初日を有償開始日とする
      const hopeDate = new Date(this.startHopeDate)
      const year = hopeDate.getFullYear()
      const month = hopeDate.getMonth() + 2 + 1 // 翌々月（0始まりなので+1）
      const firstDay = new Date(year, month - 1, 1)
      firstDay.setHours(firstDay.getHours() + 9)
      this.startPaymentDate = firstDay.toISOString().split('T')[0]
    },
    cxImportTxt(separator = '\t') {
      const today = new Date().toISOString().split('T')[0]
      const campaignStartDate = today
      const campaignEndDate = new Date(new Date(this.startPaymentDate).getTime() - 24 * 60 * 60 * 1000).toISOString().split('T')[0]
      return [
        `${this.shopId}`,
        `${this.sfOpportunityId}`,
        `${this.name}`,
        `${today}`,
        `${tosId}`,
        '', // 代理店
        `${this.selectedPlan}`,
        `${today}`,
        '', //
        '', //
        '', //
        '', //
        '', //
        '', //
        `${this.campaignEnableCheck ? campaignName : ''}`,
        `${this.campaignEnableCheck ? campaignStartDate : ''}`,
        `${this.campaignEnableCheck ? campaignEndDate : ''}`
      ].join(separator)
    },
    loadSfCallOpportunity() {
      const unixtime = Math.floor(Date.now() / 1000)
      fetch(`/api/v1/sfo_call/?id=${this.sfOpportunityId}&tv=${unixtime}`)
          .then(response => {
            if (!response.ok) throw new Error('データ取得に失敗しました')
            return response.json()
          })
          .then(data => {
            this.shopId = data.shopId || ''
            this.name = data.name || ''
            this.startHopeDate = data.startHopeDate || ''
            this.startPaymentDate = data.startPaymentDate || ''

            this.selectedPlan = data.cxPlan || 'スタンダード'
            this.follow = data.follow
          })
          .catch(error => {
            alert(error.message)
          })
    },
    loadSfInsightOpportunity() {
      const unixtime = Math.floor(Date.now() / 1000)
      fetch(`/api/v1/sfo_insight/?id=${this.sfOpportunityId}&tv=${unixtime}`)
          .then(response => {
            if (!response.ok) throw new Error('データ取得に失敗しました')
            return response.json()
          })
          .then(data => {
            this.shopId = data.shopId || ''
            this.name = data.name || ''
            this.startHopeDate = data.startHopeDate || ''
            this.startPaymentDate = data.startPaymentDate || ''

            this.selectedPlan = data.plan || 'スタンダード'
            this.follow = data.follow
          })
          .catch(error => {
            alert(error.message)
          })
    },
    async sendImport() {
      this.enableImportBtn = false

      try {
        const csrfParam = document.querySelector('meta[name="csrf-param"]').getAttribute('content')
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        const file = new File(
            [insightImportHeader + '\n' + '\"' + this.cxImportTxt('\",\"') + '\"'],
            'dummyInsightFile.csv',
            { type: 'text/csv' }
        )

        const formData = new FormData()
        formData.append(csrfParam || 'authenticity_token', csrfToken || '')
        formData.append('insight_format_regist_create_import[new_file]', file)

        const response = await fetch('/manage/store_insight_contract_workflows/import', {
          method: 'POST',
          body: formData,
          redirect: 'manual'
        })

        if (response.type === 'opaqueredirect' || response.status === 0) {
          // opaqueredirectはCORS制約下でのリダイレクト
          alert('リダイレクト先のURLを取得できません（CORS制約）')
          if (response.status === 302) {
            alert('申請に成功しました。新しいタブで申請内容を確認してください。')
            return
          }
        }

        if (response.status >= 300 && response.status < 400) {
          const location = response.headers.get('Location')
          if (location) {
            window.open(location, '_blank')
            return
          }
        }

        if (!response.ok) throw new Error('CSVデータの送信に失敗しました')
        return await response.json()
      } catch (error) {
        alert('申請エラーです。手動で申請を行ってください。')
        this.importApi = false
      }
    },
    copy(text) {
      navigator.clipboard.writeText(text)
    }
  }
}
</script>